<template>
  <blog-category-list
    :current-category="category"
    :category-url="categoryUrl"
    @select="onSelectCategory"
  ></blog-category-list>
  <blog-post-list :category="category"></blog-post-list>
</template>

<script>
export default {
  props: {
    categoryUrl: {
      type: String,
      default: '/json/categories',
    },
    defaultCategory: {
      type: String,
    },
  },

  data() {
    return {
      category: this.defaultCategory,
    };
  },

  methods: {
    onSelectCategory(slug) {
      this.category = slug;
    },
  },
};
</script>
